module.exports = __webpack_public_path__ + "media/images/pic/contact-bg-a66ce121d47e62a2dd809521a1e6e35a.png";